import { makeUnauthenticatedNetworkRequest } from './aws-fetch.ts';
import { SignalProp, unwrapNetworkResponse } from './fetch-core.ts';

const authHost = import.meta.env.VITE_USER_POOL_Client_ID as string;
const host = import.meta.env.VITE_PUBLIC_API_GATEWAY_URL as string;

const requestResetPasswordCodeUrl = `/forgot-password`;

export interface ResetPasswordCodeReq {
  username: string;
}

export interface ResetPasswordCodeRes {
  username: string;
}

export async function requestResetPasswordCode({
  username,
  signal,
}: ResetPasswordCodeReq & SignalProp) {
  const requestWithClientId = {
    username: username,
    clientId: authHost,
  };

  const res = await makeUnauthenticatedNetworkRequest({
    method: 'POST',
    baseUrl: host,
    relativeUrl: requestResetPasswordCodeUrl,
    body: requestWithClientId,
    signal,
  });

  return await unwrapNetworkResponse<ResetPasswordCodeRes>(res);
}

export const updatePasswordUrl = `/forgot-password/confirm`;

export interface UpdatePasswordReq {
  username: string;
  confirmationCode: string;
  password: string;
}

export type UpdatePasswordRes = void;

export async function updatePassword({
  username,
  confirmationCode,
  password,
  signal,
}: UpdatePasswordReq & SignalProp) {
  const requestWithClientId = {
    username: username,
    confirmationCode: confirmationCode,
    password: password,
    clientId: authHost,
  };

  const res = await makeUnauthenticatedNetworkRequest({
    method: 'POST',
    baseUrl: host,
    relativeUrl: updatePasswordUrl,
    body: requestWithClientId,
    signal,
  });

  try {
    return await unwrapNetworkResponse<UpdatePasswordRes>(res) ?? true;
  } catch (_e) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
}
